<template>
  <el-dialog
    title="订单明细清单"
    :visible="true"
    width="80%"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="orderid" label="订单ID"> </el-table-column>
      <el-table-column prop="orderitemid" label="订单明细ID"> </el-table-column>
      <el-table-column prop="productid" label="商品ID"> </el-table-column>
      <el-table-column prop="productName" label="商品名称"> </el-table-column>
      <el-table-column prop="machineid" label="机器ID">
        <template slot-scope="scope">
          <router-link
            class="link-div"
            tag="div"
            :to="{ name: 'machine', query: { machineid: scope.row.machineid } }"
            >{{ scope.row.machineid }}</router-link
          >
        </template>
      </el-table-column>
      <el-table-column prop="quantity" label="数量"> </el-table-column>
      <el-table-column label="价格(元)">
        <template slot-scope="scope">
          <div>{{ scope.row.price | formatPrice }}</div>
        </template>
      </el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="scope">
          <div>{{ scope.row.createtime | formatDateTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="修改时间">
        <template slot-scope="scope">
          <div>{{ scope.row.modifiedtime | formatDateTime }}</div>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
export default {
  props: ["tableData"],
  data() {
    return {};
  },
  methods: {
    handleClose() {
      this.$emit("closeDialog");
    }
  }
};
</script>

<style lang="less" scoped></style>
